<template>
  <button class="switch">
    <span class="switch__title">
      <slot />
    </span>
    <span class="switch__icon" />
  </button>
</template>

<script lang="ts">
  export default defineNuxtComponent({
    name: 'ArchiveTopSwitch',
  });
</script>

<style lang="scss" scoped>
  .switch {
    display: flex;
    align-items: center;

    &__title + &__icon {
      margin-left: 8px;
    }

    &__title {
      font-family: $headline-font--1;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: $mainBlack;
    }

    &__icon {
      width: 16px;
      height: 16px;
      @include dropdownIcon;
      background-color: $actionUiColor;
    }
  }
</style>
